<template>
	<div>
		<el-dialog
			:visible.sync="deleteDialog"
			width="30%"
			title="Confirmation Dialog"
			class="header hide-overflow"
			:before-close="cancel"
		>
			<span>{{ confirmationTitle }}</span>
			
			<el-row style="margin-top:50px">
				<el-col :span="6" :offset="12">
				<el-button class="button-class-white3" @click="cancel">Cancel</el-button>
				</el-col>
				<el-col :span="6">
					<el-button style="margin-top:-20px" class="button-class" @click="success">Confirm</el-button>
				</el-col>
			</el-row>
		</el-dialog>
	</div>
</template>

<script>
export default {
	props: {
		deleteDialog: Boolean,
		confirmationObject: Object,
		confirmationTitle: String,
		calling_delete: Boolean,
	},
	mounted() {
		console.log(this.confirmationObject, "confirmationObject");
	},
	methods: {
		cancel() {
			this.$emit("cancel");
		},
		success() {
			this.$emit("success", this.confirmationObject, this.calling_delete);
		},
	},
};
</script>

<style>

/* Adjust button height */
.button-class-white3,
.button-class {
	height: 40px; /* Adjust as needed */
}
.header .el-dialog__header {
	background: white;
	color: black;
	border-bottom: 1px solid grey;
}
.header .el-dialog__title {
	text-transform: capitalize;
	color: black;
}
.el-message-box__header {
	background-color: white;
	border: white;
}
.button-class-white3 {
	height: 40px;
	background: #ffffff;
	border-radius: 12px;
	color: #d26300;
	border: 1px solid #d26300;
}
.hide-overflow {
	overflow: hidden;
	overflow-y: hidden;
	overflow-x: hidden;
}
.el-dialog__body {
	overflow: hidden !important;
	overflow-y: hidden;
	overflow-x: hidden;
}
</style>
